module.exports = __webpack_public_path__ + "img/serve1.671b23de.jpg";